export default __webpack_public_path__ + "static/media/Thea.589763fd.jpeg";